import { ckb, en, ar } from "vuetify/locale";
export default {
    en: {
        ...en,
        discount: "Discount",
        visitor: "Visitor",
        price: "Price",
        totalPrice: "Total Price",
        darkLight: "Dark/Light Mode",
        about: "About",
        call: "Call",
        order: "Order",
        sendOrder: "Send My Order",
        back: "Back",
        orderMsg: "When you confirm your orders, select Send My Order.",
        showOrder: "Show My Order",
        sendAlert: "Waiter Called",
        scanCode: "Please scan the table barcode.",
        orderSent: "Your order was sent successfully",
        callInvoice: "Request Invoice",
        waiter: "Call Waiter",
        comment: "Comment",
        sendAlertInvoice: "Waiter called to bring your invoice",
        orderList: "Your Order List",
        errorAlert:
            "There is an error, please scan your table code again and resend your order",
        seeOrder: "Send Order",
        qrAlert: "Please scan the barcode again",
        fastAdd: "Quick Add",
        phone: "Mobile Number",
        phoneRequired: "Mobile number is required",
        phoneValid: "Enter a valid mobile number",
        address: "Address",
        addressRequired: "Address is required",
        pleaseWait: "Please wait a moment...",
        name: "Name",
        nameRequired: "Name is required",
        nameValid: "Enter a valid name",
        clickShowMenu: "Click here to show menu",
        // Feedback form
        feedbackTitle: "Rate Our Services",
        feedbackDescription: "Your feedback helps us improve our cafe service.",
        nameOptional: "Your Name (optional)",
        phoneOptional: "Mobile Number (optional)",
        rateItems: "Food Quality",
        rateService: "Service",
        rateChef: "Chef presentation",
        commentSuggestions: "Comments and suggestions",
        submitFeedback: "Send Feedback",
        feedbackSuccess: "Your feedback was sent successfully.",
        feedbackThanks: "Thanks for your feedback! Submitted.",
        feedbackErrorGeneric: "An error occurred. Please try again.",
        maxLength: "Must be less than {length} characters.",
        tableBarcodes: "Table Barcodes",
        tableBarcodesDesc: "List of all table barcodes for customers to view menu and order food",
        downloadAllBarcodes: "Download All Barcodes",
        table: "Table",
        scanForMenu: "Scan for Menu",
        link: "Link",
        barcode: "Barcode",
        barcodeDownloaded: "Barcode for table {number} downloaded",
        downloadAllStarted: "Downloading process for all barcodes started",
        linkCopied: "Link for table {number} copied",
        copyError: "An error occurred during copy",
        itemsList: "Menu Items List",
        addItem: "Add Item",
        editItem: "Edit Item",
        categoriesList: "Categories List",
        addCategory: "Add Category",
        editCategory: "Edit Category",
        mainCategory: "Main Category",
        subCategory: "Sub Category",
        parentCategory: "Parent Category",
        description: "Description / Ingredients",
        descriptionKu: "Kurdish Description",
        descriptionAr: "Arabic Description",
        descriptionEn: "English Description",
        nameKu: "Kurdish Name",
        nameAr: "Arabic Name",
        nameEn: "English Name",
        mainPrice: "Main Price",
        sizes: "Sizes",
        addSize: "Add Size",
        removeSize: "Remove Size",
        sizeNameKu: "Size Name (Kurdish)",
        sizeNameAr: "Size Name (Arabic)",
        sizeNameEn: "Size Name (English)",
        selectImage: "Select Image",
        deleteImage: "Delete Image",
        status: "Status",
        active: "Active",
        inactive: "Inactive",
        top: "Top / Featured",
        actions: "Actions",
        save: "Save",
        update: "Update",
        cancel: "Cancel",
        search: "Search...",
        filterByCategory: "Filter by Category",
        allCategories: "All Categories",
        confirmDelete: "Are you sure you want to delete?",
        delete: "Delete",
        success: "Operation successful",
        fieldRequired: "This field is required",
        itemImage: "Item Image",
        categoryImage: "Category Image",
        totalItems: "Total Items",
        totalCategories: "Total Categories",
        noData: "No data found",
        flavors: "Flavors / Scoops / Options",
        addFlavor: "Add Flavor",
        removeFlavor: "Remove Flavor",
        flavorNameKu: "Flavor Name (Kurdish)",
        flavorNameAr: "Flavor Name (Arabic)",
        flavorNameEn: "Flavor Name (English)",
        extraPrice: "Extra Price",
        maxFlavors: "Max Selection (Scoops limit)",
        maxFlavorsHint: "Leave blank for unlimited, or enter a limit like 5",
        selectFlavors: "Select Flavors",
        selectedFlavors: "Selected Flavors",
        maxAllowedReached: "You cannot select more than {max} flavors",
        flavorLimit: "Flavors Limit",
        noFlavors: "No flavors added yet",
        location: "Location",
        selectFlavor: "Select Flavor",
        scoops: "Scoops",
        balls: "Ball(s)",
        free: "Free",
        completed: "Completed ✓",
        full: "Full",
        totalSelected: "Total Selected",
        exactFlavorsRequired: "(Required selection)",
        header: "Header",
        logo: "Logo",
        facebook: "Facebook",
        instagram: "Instagram",
        tiktok: "TikTok",
        snapchat: "Snapchat",
        whatsapp: "WhatsApp",
        viber: "Viber",
        addToFavorites: "Add to favorites",
        removeFromFavorites: "Remove from favorites",
        close: "Close",
        increaseQty: "Increase quantity",
        decreaseQty: "Decrease quantity",
        changeLanguage: "Change language",
        itemsPerRow: "Items Display",
        oneItemPerRow: "1 Item Per Row",
        twoItemsPerRow: "2 Items Per Row",
        singleColumn: "1 Item",
        twoColumns: "2 Items",
        viewMode: "View Mode",
    },
    ar: {
        ...ar,
        discount: "خصم",
        visitor: "زيارة",
        price: "السعر",
        totalPrice: "المجموع الكلي",
        darkLight: "الوضع المظلم والمضيء",
        about: "حول",
        call: "اتصال",
        order: "طلب",
        sendOrder: "إرسال طلبي",
        back: "العودة",
        orderMsg: "عند التأكد من طلباتك، اختر إرسال طلبي.",
        showOrder: "عرض طلبي",
        sendAlert: "تم استدعاء النادل",
        scanCode: "يرجى مسح الباركود الخاص بالطاولة",
        orderSent: "تم إرسال طلبك بنجاح",
        callInvoice: "طلب الفاتورة",
        waiter: "استدعاء النادل",
        comment: "ملاحظة",
        sendAlertInvoice: "تم استدعاء النادل لإحضار فاتورتك",
        orderList: "قائمة طلباتك",
        errorAlert: "هناك خطأ، يرجى مسح كود الطاولة مرة أخرى وإعادة إرسال طلبك",
        seeOrder: "إرسال الطلب",
        qrAlert: "يرجى مسح الباركود مرة أخرى",
        fastAdd: "إضافة سريعة",
        phone: "رقم الهاتف المحمول",
        phoneRequired: "يجب كتابة رقم الهاتف المحمول",
        phoneValid: "اكتب رقم هاتف محمول صحيح",
        address: "العنوان",
        addressRequired: "يجب كتابة العنوان",
        pleaseWait: "يرجى الانتظار قليلاً...",
        name: "الاسم",
        nameRequired: "يجب كتابة الاسم",
        nameValid: "اكتب اسمًا صحيحًا",
        clickShowMenu: "انقر هنا لعرض القائمة",
        // Feedback form
        feedbackTitle: "تقييم خدماتنا",
        feedbackDescription: "ملاحظتك تساعدنا على تحسين خدمة المقهى.",
        nameOptional: "اسمك (اختياري)",
        phoneOptional: "رقم الهاتف المحمول (اختياري)",
        rateItems: "جودة الطعام",
        rateService: "الخدمة",
        rateChef: "عرض الطباخ",
        commentSuggestions: "الملاحظات والاقتراحات",
        submitFeedback: "إرسال التقييم",
        feedbackSuccess: "تم إرسال ملاحظتك بنجاح.",
        feedbackThanks: "شكرًا لملاحظتك! تم الإرسال.",
        feedbackErrorGeneric: "حدث خطأ، يرجى المحاولة مرة أخرى.",
        maxLength: "يجب أن يكون أقل من {length} حرفًا.",
        tableBarcodes: "رموز باركود الطاولات",
        tableBarcodesDesc: "قائمة بجميع رموز باركود الطاولات للعملاء لعرض القائمة وطلب الطعام",
        downloadAllBarcodes: "تنزيل جميع رموز الباركود",
        table: "طاولة",
        scanForMenu: "امسح للعرض القائمة",
        link: "الرابط",
        barcode: "الباركود",
        barcodeDownloaded: "تم تنزيل باركود الطاولة {number}",
        downloadAllStarted: "بدأت عملية تنزيل جميع رموز الباركود",
        linkCopied: "تم نسخ رابط الطاولة {number}",
        copyError: "حدث خطأ أثناء النسخ",
        itemsList: "قائمة الأصناف",
        addItem: "إضافة صنف",
        editItem: "تعديل الصنف",
        categoriesList: "قائمة الأقسام",
        addCategory: "إضافة قسم",
        editCategory: "تعديل القسم",
        mainCategory: "قسم رئيسي",
        subCategory: "قسم فرعي",
        parentCategory: "القسم الرئيسي",
        description: "الوصف / المكونات",
        descriptionKu: "الوصف بالكردية",
        descriptionAr: "الوصف بالعربية",
        descriptionEn: "الوصف بالإنجليزية",
        nameKu: "الاسم بالكردية",
        nameAr: "الاسم بالعربية",
        nameEn: "الاسم بالإنجليزية",
        mainPrice: "السعر الأساسي",
        sizes: "الأحجام",
        addSize: "إضافة حجم",
        removeSize: "حذف الحجم",
        sizeNameKu: "اسم الحجم (كردي)",
        sizeNameAr: "اسم الحجم (عربي)",
        sizeNameEn: "اسم الحجم (إنجليزي)",
        selectImage: "اختيار صورة",
        deleteImage: "حذف الصورة",
        status: "الحالة",
        active: "نشط",
        inactive: "غير نشط",
        top: "مميز (Top)",
        actions: "الإجراءات",
        save: "حفظ",
        update: "تحديث",
        cancel: "إلغاء",
        search: "بحث...",
        filterByCategory: "تصفية حسب القسم",
        allCategories: "جميع الأقسام",
        confirmDelete: "هل أنت متأكد من الحذف؟",
        delete: "حذف",
        success: "تمت العملية بنجاح",
        fieldRequired: "هذا الحقل مطلوب",
        itemImage: "صورة الصنف",
        categoryImage: "صورة القسم",
        totalItems: "إجمالي الأصناف",
        totalCategories: "إجمالي الأقسام",
        noData: "لا توجد بيانات",
        flavors: "النكهات / الخيارات / الكرات",
        addFlavor: "إضافة نكهة",
        removeFlavor: "حذف النكهة",
        flavorNameKu: "اسم النكهة (الكردية)",
        flavorNameAr: "اسم النكهة (العربية)",
        flavorNameEn: "اسم النكهة (الإنجليزية)",
        extraPrice: "السعر الإضافي",
        maxFlavors: "الحد الأقصى للاختيار (عدد الكرات)",
        maxFlavorsHint: "اتركه فارغاً ليكون غير محدود، أو أدخل رقماً مثل 5",
        selectFlavors: "اختيار النكهات",
        selectedFlavors: "النكهات المختارة",
        maxAllowedReached: "لا يمكنك اختيار أكثر من {max} نكهات",
        flavorLimit: "حد النكهات",
        noFlavors: "لم يتم إضافة أي نكهات بعد",
        location: "الموقع",
        selectFlavor: "اختيار النكهة",
        scoops: "كرات",
        balls: "كرة",
        free: "بێ بەرامبەر",
        completed: "مكتمل ✓",
        full: "ممتلئ",
        totalSelected: "إجمالي المختار",
        exactFlavorsRequired: "(مطلوب الاختيار)",
        header: "الصورة العلوية",
        logo: "الشعار",
        facebook: "فيسبوك",
        instagram: "إنستغرام",
        tiktok: "تيك توك",
        snapchat: "سناب شات",
        whatsapp: "واتساب",
        viber: "فايبر",
        addToFavorites: "إضافة إلى المفضلة",
        removeFromFavorites: "إزالة من المفضلة",
        close: "إغلاق",
        increaseQty: "زيادة الكمية",
        decreaseQty: "تقليل الكمية",
        changeLanguage: "تغيير اللغة",
        itemsPerRow: "عرض الأصناف",
        oneItemPerRow: "عنصر واحد في الصف",
        twoItemsPerRow: "عنصران في الصف",
        singleColumn: "١ صنف",
        twoColumns: "٢ صنف",
        viewMode: "طريقة العرض",
    },
    ckb: {
        ...ckb,
        discount: "داشکاندن",
        visitor: "سەردان",
        price: "نرخ",
        totalPrice: " کۆى گشتى",
        darkLight: "دۆخى تاریک و ڕووناک",
        about: "دەربارە",
        call: "بانگکردن",
        order: "داواکردن",
        sendOrder: "ناردنى داواکارییەکانم",
        back: "گەڕانەوە",
        orderMsg:
            "لەکاتى دڵنیابوونەوە لە داواکارییەکانت، ناردنى داواکارییەکانم هەڵبژێرە.",
        showOrder: "بینینى داواکارییەکانم",
        sendAlert: "گارسۆن بانگکرا",
        scanCode: "تکایە بارکۆدی سەرمێزەکە سکان بکە.",
        orderSent: "داواکارییەکەت بەسەرکەوتوویی نێردرا",
        callInvoice: "داواکردنى وەصڵ",
        waiter: "بانگکردنى گارسۆن",
        comment: "تێبینى",
        sendAlertInvoice: "گارسۆن بانگکرا بۆ هێنانى وەصڵەکەت",
        orderList: "لیستی داواکارییەکانت",
        errorAlert:
            "هەڵەیەک هەیە تکایە دووبارە کۆدى سەر مێزەکەت سکان بکە و داواکارییەکەت بنێرەوە",
        seeOrder: "ناردنى داواکارى",
        qrAlert: "تکایە دووبارە بارکۆدەکە سکان بکەرەوە",
        fastAdd: "زیادکردنی خێرا",
        phone: "ژمارە مۆبایل",
        phoneRequired: "پێویستە ژمارە مۆبایل بنووسیت",
        phoneValid: "ژمارە مۆبایلى دروست بنووسە",
        address: "ناونیشان",
        addressRequired: "پێویستە ناونیشان بنووسیت",
        pleaseWait: "تکایە کەمێک چاوەڕێ بکە...",
        name: "ناو",
        nameRequired: "پێویستە ناو بنووسیت",
        nameValid: "ناوی دروست بنووسە",
        clickShowMenu: "کلیک لێرە بکە بۆ بینینى مێنۆ",
        listFavorites: "لیستى دڵخوازەکانت",
        noFavorites: "هیچ خواردنێک لە لیستى دڵخوازەکانت نییە",
        scanBarcode: "تکایە سکانى بارکۆدى سەر مێزەکەت بکە",
        searchItem: "گەڕان بۆ خواردنەکان",
        noResults: "هیچ خواردنێک نەدۆزرایەوە",
        // Feedback form
        feedbackTitle: "هەڵسەنگاندنی خزمەتگوزارییەکانمان",
        feedbackDescription:
            "فیدباکی تۆ گرنگە بۆمان و یارمەتیدەرى کافێکەمانە بۆ باشترکردنی خزمەتگوزارییەکانمان.",
        nameOptional: "ناو (ئارەزوومەندانە)",
        phoneOptional: "ژمارەی تەلەفۆن (ئارەزوومەندانە)",
        rateItems: "کوالیتی خواردن",
        rateService: "خزمەتگوزاری",
        rateChef: "شێوازی پێشکەشکردن",
        commentSuggestions: "تێبینی و پێشنیارەکان",
        submitFeedback: "ناردنی هەڵسەنگاندن",
        feedbackSuccess: "فیدباکەکەت بە سەرکەوتوویی نێردرا.",
        feedbackThanks: "سوپاس بۆ پێداچوونەوەکەت! فیدباکەکەت نێردرا.",
        feedbackErrorGeneric: "هەڵەیەک ڕوویدا، تکایە دووبارە هەوڵ بدە.",
        maxLength: "پێویستە کەمتر بێت لە {length} پیت.",
        tableBarcodes: "بارکۆدی مێزەکان",
        tableBarcodesDesc: "لیستی سەرجەم بارکۆدەکانی مێزەکان بۆ بینینی مێنۆ و داواکردنی خۆراک لەلایەن کڕیارانەوە",
        downloadAllBarcodes: "داگرتنی سەرجەم بارکۆدەکان",
        table: "مێزی",
        scanForMenu: "سکان بکە بۆ مێنۆ",
        link: "لینک",
        barcode: "بارکۆد",
        barcodeDownloaded: "بارکۆدی مێزی {number} دابەزێنرا",
        downloadAllStarted: "پرۆسەی داگرتنی سەرجەم بارکۆدەکان دەستیپێکرد",
        linkCopied: "لینکی مێزی {number} کۆپیکرا",
        copyError: "هەڵەیەک ڕوویدا لە کۆپیکردندا",
        itemsList: "لیستی خواردن و خواردنەوەکان",
        addItem: "زیادکردنی خواردن",
        editItem: "دەستکاریکردنی خواردن",
        categoriesList: "لیستی پۆلێنەکان",
        addCategory: "زیادکردنی پۆلێن",
        editCategory: "دەستکاریکردنی پۆلێن",
        mainCategory: "پۆلێنی سەرەکی",
        subCategory: "پۆلێنی لاوەکی",
        parentCategory: "پۆلێنی سەرەکی",
        description: "دەربارە / پێکهاتە",
        descriptionKu: "دەربارە بە کوردی",
        descriptionAr: "دەربارە بە عەرەبی",
        descriptionEn: "دەربارە بە ئینگلیزی",
        nameKu: "ناو بە کوردی",
        nameAr: "ناو بە عەرەبی",
        nameEn: "ناو بە ئینگلیزی",
        mainPrice: "نرخی سەرەکی",
        sizes: "قەبارەکان",
        addSize: "زیادکردنی قەبارە",
        removeSize: "سڕینەوەی قەبارە",
        sizeNameKu: "ناوی قەبارە (کوردی)",
        sizeNameAr: "ناوی قەبارە (عەرەبی)",
        sizeNameEn: "ناوی قەبارە (ئینگلیزی)",
        selectImage: "دیاریکردنی وێنە",
        deleteImage: "سڕینەوەی وێنە",
        status: "دۆخ",
        active: "چالاک",
        inactive: "ناچالاک",
        top: "سەرەکی (Top)",
        actions: "گۆڕانکاری",
        save: "پاشەکەوتکردن",
        update: "نوێکردنەوە",
        cancel: "پاشگەزبوونەوە",
        search: "گەڕان",
        filterByCategory: "فلتەر بەپێی پۆلێن",
        allCategories: "هەموو پۆلێنەکان",
        confirmDelete: "دڵنیایت لە سڕینەوە؟",
        delete: "سڕینەوە",
        success: "جێبەجێ کرا",
        fieldRequired: "پێویستە ئەم خانەیە پڕبکەیتەوە",
        itemImage: "وێنەی خواردن",
        categoryImage: "وێنەی پۆلێن",
        totalItems: "کۆی خواردنەکان",
        totalCategories: "کۆی پۆلێنەکان",
        noData: "هیچ تۆمارێک نەدۆزرایەوە",
        flavors: "تام",
        addFlavor: "زیادکردنی تام",
        removeFlavor: "سڕینەوەی تام",
        flavorNameKu: "ناوی تام (کوردی)",
        flavorNameAr: "ناوی تام (عەرەبی)",
        flavorNameEn: "ناوی تام (ئینگلیزی)",
        extraPrice: "نرخی زیادە",
        maxFlavors: "زۆرترین ژمارەی هەڵبژاردن (سنووری تۆپەکان)",
        maxFlavorsHint: "ئەگەر بەتاڵ بێت بێ سنوورە، یان ژمارەیەک بنووسە بۆ نموونە 5",
        selectFlavors: "هەڵبژاردنی تامەکان",
        selectedFlavors: "تامە هەڵبژێردراوەکان",
        maxAllowedReached: "ناتوانیت لە {max} تام زیاتر هەڵبژێریت",
        flavorLimit: "سنووری تامەکان",
        noFlavors: "هیچ تامێک زیاد نەکراوە",
        location: "شوێن / ناونیشان",
        selectFlavor: "هەڵبژاردنی تام",
        scoops: "تۆپەکان",
        balls: "تۆپ",
        free: "بێ بەرامبەر",
        completed: "تەواوە ✓",
        full: "پڕبوو",
        totalSelected: "کۆی هەڵبژێردراوەکان",
        exactFlavorsRequired: "(پێویستە دیاریبکرێت)",
        header: "وێنەی سەرەوە",
        logo: "لۆگۆ",
        facebook: "فەیسبووک",
        instagram: "ئینستاگرام",
        tiktok: "تیکتۆک",
        snapchat: "سناپچات",
        whatsapp: "واتسئەپ",
        viber: "ڤایبەر",
        addToFavorites: "زیادکردن بۆ دڵخوازەکان",
        removeFromFavorites: "سڕینەوە لە دڵخوازەکان",
        close: "داخستن",
        increaseQty: "زیادکردنی بڕ",
        decreaseQty: "کەمکردنەوەی بڕ",
        changeLanguage: "گۆڕینی زمان",
        itemsPerRow: "پیشاندانی خواردنەکان",
        oneItemPerRow: "یەک دانە لە هەر ڕیزێک",
        twoItemsPerRow: "دوو دانە لە هەر ڕیزێک",
        singleColumn: "١ ئایتم",
        twoColumns: "٢ ئایتم",
        viewMode: "شێوازی پیشاندان",
    },
};
